// Messages d'erreur de formulaire, communs à toute l'application :
// - un champ obligatoire vide → « Le champ « Nom » est obligatoire. »
// - une erreur renvoyée par l'API ({ champ: [messages] }) → affichée sous le bon champ.

export const requiredMessage = (label) => `Le champ « ${label} » est obligatoire.`;

const isEmpty = (value) =>
  value === undefined || value === null ||
  (typeof value === 'string' && value.trim() === '') ||
  (Array.isArray(value) && value.length === 0);

// required : { nomDuChamp: 'Libellé affiché' } → { nomDuChamp: message } pour chaque champ vide
export function checkRequired(values, required) {
  const errors = {};
  Object.entries(required).forEach(([field, label]) => {
    if (isEmpty(values[field])) errors[field] = requiredMessage(label);
  });
  return errors;
}

// Messages DRF « vide / requis » reformulés avec le libellé du champ
const EMPTY_API_MESSAGES = [
  'Ce champ ne peut être vide.', 'Ce champ est obligatoire.', 'Ce champ ne peut être nul.',
  'This field may not be blank.', 'This field is required.', 'This field may not be null.',
];

// Erreurs de l'API → { champ: message, _global?: message }.
// labels : { champ: 'Libellé' } pour reformuler « Ce champ est obligatoire ».
export function apiFieldErrors(err, labels = {}) {
  const data = err?.response?.data;
  if (!data || typeof data !== 'object') return {};
  if (typeof data.detail === 'string') return { _global: data.detail };
  if (typeof data.error === 'string') return { _global: data.error };
  const errors = {};
  Object.entries(data).forEach(([field, messages]) => {
    let message = Array.isArray(messages) ? messages[0] : messages;
    if (typeof message !== 'string') return;
    if (labels[field] && EMPTY_API_MESSAGES.includes(message)) message = requiredMessage(labels[field]);
    if (field === 'non_field_errors') errors._global = message;
    else errors[field] = message;
  });
  return errors;
}

// Premier message lisible, préfixé du libellé du champ (pour un toast)
export function firstErrorMessage(errors, labels = {}, fallback = 'Veuillez corriger le formulaire.') {
  if (errors._global) return errors._global;
  const [field, message] = Object.entries(errors)[0] || [];
  if (!message) return fallback;
  if (message.startsWith('Le champ')) return message;
  return labels[field] ? `${labels[field]} : ${message}` : message;
}

export const ERROR_COLOR = '#dc2626';

export function FieldError({ message }) {
  if (!message) return null;
  return (
    <span role="alert" style={{ display: 'block', color: ERROR_COLOR, fontSize: '0.78rem', marginTop: 4 }}>
      {message}
    </span>
  );
}

// Astérisque rouge des libellés de champs obligatoires
export function Req() {
  return <span aria-hidden="true" style={{ color: ERROR_COLOR, marginLeft: 2 }}>*</span>;
}
